import Leagues from '@/modules/leagues/Leagues.vue';
import LeagueProfile from '@/modules/leagues/components/profile/Profile.vue';
import LeagueTeam from '@/modules/leagues/components/team/LeagueTeam.vue';
import LeagueMarket from '@/modules/leagues/components/market/Market.vue';
import LeagueMarketTransfers from '@/modules/leagues/components/market/components/Transfers.vue';
import LeagueMarketOffers from '@/modules/leagues/components/market/components/Offers.vue';
import LeagueMarketSales from '@/modules/leagues/components/market/components/Sales.vue';
import LeagueNews from '@/modules/leagues/components/news/News.vue';

export default [
    {
        path: '/my-leagues',
        name: 'My Leagues',
        component: Leagues,
        meta: { requiresNavbar: true },
        children: [
            {
                path: '/my-leagues/',
                name: 'LeaguesProfile',
                component: LeagueProfile,
                meta: { requiresNavbar: true },
            },
            {
                path: '/my-leagues/team',
                name: 'LeaguesTeam',
                component: LeagueTeam,
                meta: { requiresNavbar: true },
            },
            {
                path: '/my-leagues/market',
                name: 'LeaguesMarket',
                component: LeagueMarket,
                meta: { requiresNavbar: true },
                children: [
                    {
                        path: '/my-leagues/market',
                        name: 'LeagueMarketTransfers',
                        component: LeagueMarketTransfers,
                        meta: { requiresNavbar: true },
                    },
                    {
                        path: '/my-leagues/market/sales',
                        name: 'LeagueMarketSales',
                        component: LeagueMarketSales,
                        meta: { requiresNavbar: true },
                    },
                    {
                        path: '/my-leagues/market/offers',
                        name: 'LeagueMarketOffers',
                        component: LeagueMarketOffers,
                        meta: { requiresNavbar: true },
                    },
                ],
            },
            {
                path: '/my-leagues/news',
                name: 'LeagueNews',
                component: LeagueNews,
                meta: { requiresNavbar: true },
            },
        ],
    }
]
